import React from 'react'
import { Trans } from '@lingui/macro'
import { IScormPageProps } from './ManageScormPage'
import { TopicElementTypeEnum } from '../../../../types/TopicElementTypeEnum'
import TextElement from '../topic-detail-page/components/text-element/TextElement'
import { ButtonLight } from 'front-end/src/components'
import IconPlus from '../../components/common/icon/IconPlusInCircle'
import { useCreateElementMutation } from '../topic-detail-page/components/choose-element/operations/createElement.codegen'

export const ManageScormPageTextElement = (props: IScormPageProps) => {
  const [createElement] = useCreateElementMutation()
  const { topic } = props
  const handleCreateElement = () => async () => {
    await createElement({
      variables: {
        topicId: props.topic.id,
        type: TopicElementTypeEnum.TEXT
      }
    })
    props.fetchTopic()
  }

  return (
    <div className="ManageScormPageTextElement">
      {topic.draftVersion?.elements &&
        topic.draftVersion?.elements.length === 0 && (
          <div className="ManageScormPageTextElement__new-element">
            <ButtonLight
              onClick={handleCreateElement()}
              leftIcon={<IconPlus />}
            >
              <Trans>Add text and images</Trans>
            </ButtonLight>
          </div>
        )}
      {topic.draftVersion?.elements &&
        topic.draftVersion?.elements.length === 1 && (
          <div className={`page page-text`} key={topic.id}>
            <div
              className={`page-content page-content-text element-wrap element-text element-mode-view`}
            >
              <TextElement
                key={topic.draftVersion?.elements[0].id}
                {...{
                  element: topic.draftVersion?.elements[0],
                  isMultiPage: false,
                  topic
                }}
              />
            </div>
          </div>
        )}
    </div>
  )
}
